(() => {
  const ACK_TEXT = 'I acknowledge that handmade food products sent by post may experience movement, cracking or cosmetic changes during transit.';
  const RIGHTS_TEXT = 'This does not affect your statutory rights.';
  const ERROR_TEXT = 'Please tick this box before proceeding to checkout.';
  let acknowledged = false;

  function removeAcceleratedCheckout() {
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach((element) => {
      element.remove();
    });
  }

  function createAcknowledgement(container, formId, suffix) {
    if (!container || container.querySelector('.bakehouse-transit-acknowledgement')) return;

    const checkout = container.querySelector('button[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!checkout) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'bakehouse-transit-acknowledgement';

    const label = document.createElement('label');
    label.className = 'bakehouse-transit-acknowledgement__label';

    const input = document.createElement('input');
    input.id = `BakehouseTransitAcknowledgement-${suffix}`;
    input.className = 'bakehouse-transit-acknowledgement__input';
    input.type = 'checkbox';
    input.name = 'attributes[Transit acknowledgement]';
    input.value = 'Accepted';
    input.required = true;
    input.checked = acknowledged;
    input.setAttribute('form', formId);

    const text = document.createElement('span');
    text.textContent = ACK_TEXT;

    label.htmlFor = input.id;
    label.append(input, text);

    const rights = document.createElement('p');
    rights.className = 'bakehouse-transit-acknowledgement__rights';
    rights.textContent = RIGHTS_TEXT;

    const error = document.createElement('p');
    error.className = 'bakehouse-transit-acknowledgement__error';
    error.textContent = ERROR_TEXT;
    error.hidden = true;

    wrapper.append(label, rights, error);
    container.insertBefore(wrapper, checkout);

    input.addEventListener('change', () => {
      acknowledged = input.checked;
      document.querySelectorAll('.bakehouse-transit-acknowledgement__input').forEach((otherInput) => {
        otherInput.checked = acknowledged;
      });
      document.querySelectorAll('.bakehouse-transit-acknowledgement').forEach((acknowledgement) => {
        acknowledgement.classList.remove('is-invalid');
        const acknowledgementError = acknowledgement.querySelector('.bakehouse-transit-acknowledgement__error');
        if (acknowledgementError) acknowledgementError.hidden = true;
      });
    });
  }

  function showErrorForCheckout(checkout) {
    const container = checkout.closest('.cart__ctas');
    const wrapper = container?.querySelector('.bakehouse-transit-acknowledgement');
    const input = wrapper?.querySelector('.bakehouse-transit-acknowledgement__input');

    if (!input || input.checked) return true;

    wrapper.classList.add('is-invalid');
    const error = wrapper.querySelector('.bakehouse-transit-acknowledgement__error');
    if (error) error.hidden = false;

    input.focus();
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.reportValidity();
    return false;
  }

  function init() {
    removeAcceleratedCheckout();

    const mainCart = document.querySelector('#main-cart-footer .cart__ctas') ||
      document.querySelector('.cart__footer-wrapper .cart__ctas');
    createAcknowledgement(mainCart, 'cart', 'Cart');

    const drawerCart = document.querySelector('#CartDrawer .cart__ctas') ||
      document.querySelector('cart-drawer .cart__ctas');
    createAcknowledgement(drawerCart, 'CartDrawer-Form', 'Drawer');
  }

  document.addEventListener('click', (event) => {
    const checkout = event.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout');
    if (!checkout) return;

    if (!showErrorForCheckout(checkout)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', (event) => {
    if (!['cart', 'CartDrawer-Form'].includes(event.target.id)) return;

    const submitter = event.submitter;
    if (!submitter) return;

    if (submitter.name === 'checkout' || submitter.id === 'checkout' || submitter.id === 'CartDrawer-Checkout') {
      if (!showErrorForCheckout(submitter)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
  }, true);

  let pending = false;
  const scheduleInit = () => {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(() => {
      pending = false;
      init();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  new MutationObserver(scheduleInit).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
